import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import FacilityPrfile from './FacilityProfile';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SocialData from './SocialData';
import GovernanceData from './GovernanceData';
import { saveFacilityId } from '../../store/slices/FacilitiesSlice';


export default function FacilityDetails() {
    const [activeTab, setActiveTab] = useState("environmental");
    const { state } = useLocation();
    const dispatch = useDispatch();
    // const facilitiesData = useSelector((state) => state.facilities.data.facilitiesdata)

    if (state && Object.keys(state).length > 0) {
        dispatch(saveFacilityId(state));
    }

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2 arrow-and-title">
                    <Link to="/assets">
                        <i className="fa-solid fa-arrow-left"></i>
                    </Link>
                    {/* <h1 className="h2">{state.name}</h1> */}
                    <div className="facility-inner">
                        <span><b>{state && state.name}</b></span>
                        <span>
                            <b>{state && state.location}</b>
                        </span>
                        {/* <span>Fuel station to refuel vehicle </span> */}
                    </div>
                </h1>

            </div>

            <nav>
                <div className="nav nav-tabs team-mngmt-tab" id="nav-tab" role="tablist">
                    <button
                        className={`nav-link ${activeTab === 'environmental' ? 'active' : ''}`}
                        id="nav-department-tab"
                        data-bs-toggle="tab"
                        type="button"
                        role="tab"
                        aria-controls="nav-department"
                        aria-selected={activeTab === 'environmental'}
                        onClick={() => toggleTab('environmental')}
                    >
                        <b>Environmental</b>
                    </button>
                    <button
                        className={`nav-link ${activeTab === 'social' ? 'active' : ''}`}
                        id="nav-employee-tab"
                        data-bs-toggle="tab"
                        type="button"
                        role="tab"
                        aria-controls="nav-employee"
                        aria-selected={activeTab === 'social'}
                        onClick={() => toggleTab('social')}
                    >
                        <b>Social</b>
                    </button>
                    <button
                        className={`nav-link ${activeTab === 'governance' ? 'active' : ''}`}
                        id="nav-supplier-tab"
                        data-bs-toggle="tab"
                        type="button"
                        role="tab"
                        aria-controls="nav-supplier"
                        aria-selected={activeTab === 'governance'}
                        onClick={() => toggleTab('governance')}
                    >
                        <b>Governance</b>
                    </button>
                </div>
            </nav>

            <div className="tab-content" id="nav-tabContent">
                <div
                    className={`tab-pane fade ${activeTab === 'environmental' ? 'show active' : ''}`}
                    id="nav-department"
                    role="tabpanel"
                    aria-labelledby="nav-department-tab"
                >
                    <FacilityPrfile state={state} />
                </div>
                <div
                    className={`tab-pane fade ${activeTab === 'social' ? 'show active' : ''}`}
                    id="nav-employee"
                    role="tabpanel"
                    aria-labelledby="nav-employee-tab"
                >
                    <SocialData />
                </div>
                <div
                    className={`tab-pane fade ${activeTab === 'governance' ? 'show active' : ''}`}
                    id="nav-supplier"
                    role="tabpanel"
                    aria-labelledby="nav-supplier-tab"
                >
                    <GovernanceData />
                </div>
            </div>
        </main>
    );


}
